import { DestroyRef, afterNextRender } from '@angular/core';
import { Directive, ElementRef, Output, EventEmitter, OnDestroy, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReplaySubject, debounceTime, shareReplay, startWith } from 'rxjs';


@Directive({
    standalone: true,
    selector: '[hostResize]'
})
export class HostResizeDirective implements OnDestroy {
    @Output() widthChange = new EventEmitter<number>();
    private readonly emitWidth$ = new ReplaySubject<number>(1);

    @Input() debounce = 100
    private resizeObserver!: ResizeObserver;

    protected readonly destroyRef = inject(DestroyRef)
    public readonly el = inject(ElementRef)
    width = this.el.nativeElement.clientWidth

    onServer = true
    constructor() {

        afterNextRender(() => {
            this.onServer = false
            this.emitWidth$.pipe(
                startWith(this.width),
                takeUntilDestroyed(this.destroyRef),
                debounceTime(this.debounce),
                shareReplay(1)
            ).subscribe(this.widthChange);

            this.resizeObserver = new ResizeObserver(entries => {
                for (const entry of entries) {
                    if (entry.contentRect.width === this.width) continue
                    this.width = entry.contentRect.width
                    this.emitWidth$.next(entry.contentRect.width);
                }
            });
            this.resizeObserver.observe(this.el.nativeElement);
        })

    }

    ngOnDestroy() {
        this.resizeObserver?.disconnect();
        this.emitWidth$?.complete()
    }
}